<div class="main-container">
  <div class="login-container">
    <div class="left-container"></div>
    <div class="right-container"></div>
    <div class="sign-container">
      <div class="sign-left-container">
        <div class="p-4 p-md-5 flex-grow-1 form-body" >

          <div class="text-center text-md-start">
            <!-- <h4 class="mb-0" style = "font-weight:500;font-family: 'Poly';">
              Forgot your password?
            </h4> -->
            <!-- <p class="mb-4" style = "font-family: 'Poly';">
              Enter your Email.
            </p> -->
          </div>
          <div class="row justify-content-center">

            <div class="col-sm-8 col-md">

              <form *ngIf="!verifyShow" [formGroup]="forgetPassForm" class="mb-3">

                <h4 class="mb-0" style = "font-weight:500;font-family: 'Poly';">
                  Forgot your password?
                </h4>

                <label for = "email" style="font-size: 14px;font-family: 'Poly';margin-bottom: 16px;">Enter your Email</label>

                <input name="email" class="form-control mb-2" formControlName="forgetpass"
                    type="email" placeholder="Email address"
                    [ngClass]="{
                    'is-invalid': (f.forgetpass.invalid && f.forgetpass.touched) && submitted }" />
                <mat-error class="text-danger"
                  *ngIf="(submitted || f.forgetpass.touched)">
                  <mat-error *ngIf="f.forgetpass.errors?.required" style = "font-family: 'Poppins';">
                    Email Is Required.
                  </mat-error>
                  <mat-error *ngIf="f.forgetpass.errors?.pattern" style = "font-family: 'Poppins';">
                    Email Is Required in Format.
                  </mat-error>
                </mat-error>

                <button class="btn btn-primary d-block w-100 mt-3" type="submit" style="background: #110152;height:40px;"
                  name="submit" (click)="postforgotpassword()">
                  <span style = "font-family: 'Poly';">Send</span>
                </button>

              </form>

              <form *ngIf="verifyShow" [formGroup]="verifyPasswordFrom" class="mb-3">
                  <input readonly class="form-control mb-2" formControlName="email"
                      type="email" placeholder="Email address" />
                  <label for="otp" style = "font-family: 'Poly';">Enter OTP</label>
                  <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config">
                  </ng-otp-input>

            <div class="position-relative mb-3">
            <input class="form-control my-2 mb-3" formControlName="newPassword"
                type="{{ showNewPassword ? 'text' : 'password' }}" placeholder="Enter New Password"
                [ngClass]="{
                    'is-invalid': (verifyPasswordFromControl.newPassword.invalid && verifyPasswordFromControl.newPassword.touched) }" />
            <button type="button" class="btn btn-link password-toggle-button" (click)="toggleNewPasswordVisibility()">
                <i class="fa" [ngClass]="{'fa-eye': showNewPassword, 'fa-eye-slash': !showNewPassword}"></i>
            </button>
            </div>
            <mat-error class="text-danger"
                 *ngIf="(verifyPasswordFromControl.newPassword.touched)">
                <mat-error *ngIf="verifyPasswordFromControl.newPassword.errors?.required" style="font-family: 'Poppins';">
                    New Password Is Required.
                </mat-error>
            </mat-error>

            <div class="position-relative mb-3">
            <input class="form-control" formControlName="confirmPassword"
                type="{{ showConfirmPassword ? 'text' : 'password' }}" placeholder="Confirm Password"
                [ngClass]="{
                'is-invalid': (verifyPasswordFromControl.confirmPassword.invalid && verifyPasswordFromControl.confirmPassword.touched) }" />
            <button type="button" class="btn btn-link password-toggle-button" (click)="toggleConfirmPasswordVisibility()">
                <i class="fa" [ngClass]="{'fa-eye': showConfirmPassword, 'fa-eye-slash': !showConfirmPassword}"></i>
            </button>
            </div>
            <mat-error class="text-danger"
                *ngIf="(verifyPasswordFromControl.confirmPassword.touched)">
                <mat-error *ngIf="verifyPasswordFromControl.confirmPassword.errors?.required" style="font-family: 'Poppins';">
                    Confirm Password Is Required.
                </mat-error>
                <mat-error *ngIf="verifyPasswordFromControl.confirmPassword.errors?.confirmedValidator" style="font-family: 'Poppins';">
                    Password & Confirm Password must be same.
                </mat-error>
            </mat-error>

                  <button class="btn btn-primary d-block w-100 mt-3" type="submit" style="background: #110152;height:40px;"
                      name="submit" (click)="postverifypassword()">
                      <span style = "font-family: 'Poly';">Submit</span>
                  </button>
              </form>

              <a class="fs--1 text-600" routerLink="/auth/role-selection" style = "font-family: 'Poly';">
                Back to Login page
                <span class="d-inline-block ms-1">&rarr;</span>
              </a>

            </div>

          </div>
        </div>
      </div>
      <div class="sign-right-container">
        <img src = "../../../../assets/img/dashboard-party-profiles/login-pic.png" class = "rightImage">
      </div>
    </div>
  </div>
</div>





<!-- <main class="main" id="top">
    <div class="container-fluid">
        <div class="row min-vh-100 flex-center g-0">
            <div class="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-7 py-3 position-relative">
                <div class="card overflow-hidden z-index-1">
                    <div class="card-body p-0">
                        <div class="row g-0 h-100">
                            <div class="col-sm-12 col-md-6 col-lg-6 bg-card-gradient">

                                <div class="position-relative pt-md-3 pb-md-7 light" style = "padding-top: 150px !important;">
                                  <div class="z-index-1 position-relative p-4">

                                      <p class="mt-2 d-flex">
                                          <img src="assets/img/icons/spot-illustrations/Logo-2.png"
                                              alt="iceipts logo" width="40" height="40" style="position: absolute !important; top: -17% !important;left: 45%">
                                          <img src="assets/img/icons/spot-illustrations/Logo-1.png"
                                              alt="iceipts logo" width="130" height="20" style = "margin:auto;">
                                      </p>
                                      <br><br>
                                      <p class="opacity-75 text-white d-flex justify-content-center leftText">
                                          The technology that looks impossible today will<br>be part of our life
                                          tomorrow. Iceipts technology<br>creating difference.
                                      </p>
                                  </div>
                              </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6 form-box">
                                <div class="p-4 p-md-5 flex-grow-1 form-body" >
                                    <div class="text-center text-md-start">
                                        <h4 class="mb-0" style = "font-weight:500;font-family: 'Poppins';">Forgot your password?</h4>
                                        <p class="mb-4" style = "font-family: 'Poppins';">
                                            Enter your Email and we'll send you a reset link.
                                        </p>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-sm-8 col-md">
                                            <form *ngIf="!verifyShow" [formGroup]="forgetPassForm" class="mb-3">


                                                <input class="form-control mb-2" formControlName="forgetpass"
                                                    type="email" placeholder="Email address"
                                                    [ngClass]="{
                                                    'is-invalid': (f.forgetpass.invalid && f.forgetpass.touched) && submitted }" />
                                                <mat-error class="text-danger"
                                                    *ngIf="(submitted || f.forgetpass.touched)">
                                                    <mat-error *ngIf="f.forgetpass.errors?.required" style = "font-family: 'Poppins';">
                                                        Email Is Required!
                                                    </mat-error>
                                                    <mat-error *ngIf="f.forgetpass.errors?.pattern" style = "font-family: 'Poppins';">
                                                        Email Is Required in Format!
                                                    </mat-error>
                                                </mat-error>

                                                <button class="btn btn-primary d-block w-100 mt-3" type="submit" style="background: #110152;"
                                                    name="submit" (click)="postforgotpassword()">
                                                    <span style = "font-family: 'Poppins';">Send reset link</span>
                                                </button>
                                            </form>

                                            <form *ngIf="verifyShow" [formGroup]="verifyPasswordFrom" class="mb-3">
                                                <input readonly class="form-control mb-2" formControlName="email"
                                                    type="email" placeholder="Email address" />
                                                <label for="otp" style = "font-family: 'Poppins';">Enter OTP</label>
                                                <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config">
                                                </ng-otp-input>

                                                <input class="form-control my-2" formControlName="newPassword"
                                                    type="email" placeholder="Enter New Password"
                                                    [ngClass]="{
                                                            'is-invalid': (verifyPasswordFromControl.newPassword.invalid && verifyPasswordFromControl.newPassword.touched) }" />
                                                <mat-error class="text-danger"
                                                    *ngIf="(verifyPasswordFromControl.newPassword.touched)">
                                                    <mat-error
                                                        *ngIf="verifyPasswordFromControl.newPassword.errors?.required" style = "font-family: 'Poppins';">
                                                        New Password Is Required!
                                                    </mat-error>
                                                </mat-error>

                                                <input class="form-control mb-2" formControlName="confirmPassword"
                                                    type="text" placeholder="Confirm Password"
                                                    [ngClass]="{
                                                        'is-invalid': (verifyPasswordFromControl.confirmPassword.invalid && verifyPasswordFromControl.confirmPassword.touched) }" />
                                                <mat-error class="text-danger"
                                                    *ngIf="(verifyPasswordFromControl.newPassword.touched)">
                                                    <mat-error
                                                        *ngIf="verifyPasswordFromControl.confirmPassword.errors?.required" style = "font-family: 'Poppins';">
                                                        Confirm Password Is Required!
                                                    </mat-error>
                                                    <mat-error
                                                        *ngIf="verifyPasswordFromControl.confirmPassword.errors?.confirmedValidator" style = "font-family: 'Poppins';">
                                                        Password & Confirm Password must be same!
                                                    </mat-error>
                                                </mat-error>

                                                <button class="btn btn-primary d-block w-100 mt-3" type="submit" style="background: #110152;"
                                                    name="submit" (click)="postverifypassword()">
                                                    <span style = "font-family: 'Poppins';">Submit</span>
                                                </button>
                                            </form>
                                            <a class="fs--1 text-600" routerLink="/auth/login" style = "font-family: 'Poppins';">Back to Login page<span
                                                    class="d-inline-block ms-1">&rarr;</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main> -->
